import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
// import querystring from 'querystring'

const topicConfigApi = {
  list (params) {
    return axios.get(`${ApiSetting.baseUrl}/api/topic-config/`, {params: params})
  },
  detail (topicConfigId, params) {
    return axios.get(`${ApiSetting.baseUrl}/api/topic-config/${topicConfigId}/`, {params: params})
  }
}

export default topicConfigApi
